export default __webpack_public_path__ + "static/media/pompavana-logo-disabled.f5cac0f4.svg";